import React from 'react';
import { hasResource } from 'utils/resourceAuth';

export interface HasResourceProps {
  resourceCodes: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * 根据资源码控制子内容是否渲染：当用户拥有任何一个 resourceCode 时渲染 children，否则渲染 fallback（默认 null）
 */
export function HasResource({ resourceCodes, children, fallback = null }: HasResourceProps): React.ReactElement | null {
  const has = hasResource(resourceCodes);
  return has ? <>{children}</> : <>{fallback}</>;
}
